package com.milta.feature.imports.domain.entity

import com.milta.feature.route.domain.entity.GeocodeFailureReason
import com.milta.feature.route.domain.entity.GeocodeStatus

/**
 * One row of `POST /api/v1/imports/pdf`'s `Deliveries[]` array (MIL-26). Claude Haiku reads the
 * PDF's native text directly when present, or performs visual OCR itself on a scanned PDF — no
 * separate OCR library is involved. [missingFields] lists the fields the model could not read for
 * this specific row; its exact scope is not specified by the contract (same ambiguity already
 * documented on [com.milta.feature.ocrscan.domain.entity.ScannedDelivery.hasMissingFields] for the
 * photo scan flow — see the MIL-26 mockup's own reviewer note) — the presentation layer does NOT
 * rely on it to decide whether a row blocks "Ajouter à la tournée"; it checks [recipientName]/
 * [address] nullity directly instead, mirroring `DeliveryRowUi.isComplete`.
 */
data class ExtractedDelivery(
    val tempId: String,
    val recipientName: String?,
    val address: String?,
    val phoneNumber: String?,
    /** Raw "HH:mm" string — mirrors [com.milta.feature.ocrscan.domain.entity.ScannedDelivery.deadlineTime]. */
    val deadlineTime: String?,
    val missingFields: List<String>,
    val packageCount: Int,
    /** HERE validation outcome of [address], resolved server-side before this row reached the client. */
    val geocodeStatus: GeocodeStatus = GeocodeStatus.Pending,
    val latitude: Double? = null,
    val longitude: Double? = null,
    /** Retour 26/10 (R1/R11) — why HERE refused [address] (Failed only), null otherwise. */
    val geocodeFailureReason: GeocodeFailureReason? = null,
    /** Retour 29/10 — the address HERE matched ("Trouvée : …"), null when not reported (older data). */
    val resolvedAddress: String? = null,
)
